export const includeFields = async (
  fields: string[],
  data: Record<string, any>[],
): Promise<Record<string, any>[]> => {
  return data
    .filter((item) => {
      const hsCode = item['HS Code'];
      const nameOfEntity = item['Name of Entity'];
      const isArchivedHS =
        typeof hsCode === 'string' && hsCode.includes('- Archived');
      const isArchivedName =
        typeof nameOfEntity === 'string' && nameOfEntity.includes('- Archived');
      return !isArchivedHS && !isArchivedName;
    })
    .flatMap((item) =>
      fields.reduce((newItem: any, field) => {
        if (field in item) {
          newItem[field] = item[field];
        }
        return newItem;
      }, {}),
    );
};
